var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCubeArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 24h24V0H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  fillRule: "nonzero",
  d: "M21.524 15.861 12 6.337l-1.06 1.06L5.036 13.3l-2.561 2.561z",
  className: "arrow-outline"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  fillRule: "nonzero",
  d: "M6.097 14.361 12 8.458l5.903 5.903z",
  className: "arrow-center"
}))));
export default SvgCubeArrowIcon;